// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/emails.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AttachmentLite } from "./attachments_pb";
import { file_cortado_v1_attachments } from "./attachments_pb";
import type { EmailBodyFetchStatusEnum, ParentTypeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/emails.proto.
 */
export const file_cortado_v1_emails: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_attachments, file_cortado_v1_settings, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * EmailSuppression represents an email address that should not receive outbound email
 *
 * @generated from message cortado.v1.EmailSuppression
 */
export type EmailSuppression = Message<"cortado.v1.EmailSuppression"> & {
  /**
   * Unique identifier for the suppression record
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the suppression belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * The email address that is suppressed
   *
   * @generated from field: string email_address = 3;
   */
  emailAddress: string;

  /**
   * Reason the address was suppressed (server-set; manual creates always record MANUAL)
   *
   * @generated from field: cortado.v1.EmailSuppressionReason reason = 4;
   */
  reason: EmailSuppressionReason;

  /**
   * Email that triggered the suppression (optional; e.g., the bouncing/complained email)
   *
   * @generated from field: optional string source_email_id = 5;
   */
  sourceEmailId?: string;

  /**
   * Free-form notes about the suppression (optional)
   *
   * @generated from field: optional string notes = 6;
   */
  notes?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.EmailSuppression.
 * Use `create(EmailSuppressionSchema)` to create a new message.
 */
export const EmailSuppressionSchema: GenMessage<EmailSuppression> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 0);

/**
 * EmailParticipant represents a participant in an email thread
 *
 * @generated from message cortado.v1.EmailParticipant
 */
export type EmailParticipant = Message<"cortado.v1.EmailParticipant"> & {
  /**
   * Email address of the participant
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * Display name of the participant (optional)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Type of participant (e.g., "customer", "user", "cc")
   *
   * @generated from field: string type = 3;
   */
  type: string;
};

/**
 * Describes the message cortado.v1.EmailParticipant.
 * Use `create(EmailParticipantSchema)` to create a new message.
 */
export const EmailParticipantSchema: GenMessage<EmailParticipant> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 1);

/**
 * EmailThreadLite is a lightweight version of EmailThread for list views
 *
 * @generated from message cortado.v1.EmailThreadLite
 */
export type EmailThreadLite = Message<"cortado.v1.EmailThreadLite"> & {
  /**
   * Unique identifier for the email thread
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the thread belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Subject of the email thread
   *
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * Current status of the thread
   *
   * @generated from field: cortado.v1.EmailThreadStatus status = 4;
   */
  status: EmailThreadStatus;

  /**
   * Participants in the thread
   *
   * @generated from field: repeated cortado.v1.EmailParticipant participants = 5;
   */
  participants: EmailParticipant[];

  /**
   * User ID the thread is assigned to (optional)
   *
   * @generated from field: optional string assigned_to = 6;
   */
  assignedTo?: string;

  /**
   * Name of the assigned user (optional)
   *
   * @generated from field: optional string assigned_to_name = 7;
   */
  assignedToName?: string;

  /**
   * Number of messages in the thread
   *
   * @generated from field: int32 message_count = 8;
   */
  messageCount: number;

  /**
   * Timestamp of the last message (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp last_message_at = 9;
   */
  lastMessageAt?: Timestamp;

  /**
   * Direction of the last message (optional)
   *
   * @generated from field: optional cortado.v1.EmailMessageDirection last_message_direction = 10;
   */
  lastMessageDirection?: EmailMessageDirection;

  /**
   * Preview of the last message (optional, truncated to ~100 chars)
   *
   * @generated from field: optional string last_message_preview = 11;
   */
  lastMessagePreview?: string;

  /**
   * Contact ID this thread is linked to (optional)
   *
   * @generated from field: optional string contact_id = 12;
   */
  contactId?: string;

  /**
   * Name of the linked contact (optional)
   *
   * @generated from field: optional string contact_name = 13;
   */
  contactName?: string;

  /**
   * Inquiry ID this thread is linked to (optional)
   *
   * @generated from field: optional string inquiry_id = 14;
   */
  inquiryId?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp;

  /**
   * Timestamp when this snoozed thread should reopen (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp snoozed_until = 16;
   */
  snoozedUntil?: Timestamp;

  /**
   * Whether the current user has a saved draft in this thread
   *
   * @generated from field: bool has_current_user_draft = 50;
   */
  hasCurrentUserDraft: boolean;

  /**
   * Whether this thread has a message newer than the current user's read position
   *
   * @generated from field: bool is_unread = 51;
   */
  isUnread: boolean;

  /**
   * Whether the current user muted this thread. Set by ListEmailThreads only.
   *
   * @generated from field: bool is_muted = 52;
   */
  isMuted: boolean;

  /**
   * Why the thread waits in NEEDS_REVIEW, when it does. Set by
   * ListEmailThreads only.
   *
   * @generated from field: optional cortado.v1.EmailThreadReviewReason review_reason = 17;
   */
  reviewReason?: EmailThreadReviewReason;

  /**
   * Connected mailbox the thread came in on, and its address. Set by
   * ListEmailThreads only.
   *
   * @generated from field: optional string connected_mailbox_id = 18;
   */
  connectedMailboxId?: string;

  /**
   * @generated from field: optional string connected_mailbox_email = 19;
   */
  connectedMailboxEmail?: string;

  /**
   * Whether that mailbox is no longer active (disconnected or waiting for a
   * reconnect), so its mail no longer syncs.
   *
   * @generated from field: bool connected_mailbox_inactive = 20;
   */
  connectedMailboxInactive: boolean;

  /**
   * The lead or booking the thread is linked to: a booking first, else a
   * lead, the most recent link of that kind. Set by ListEmailThreads only.
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum linked_entity_type = 21;
   */
  linkedEntityType?: ParentTypeEnum;

  /**
   * @generated from field: optional string linked_entity_id = 22;
   */
  linkedEntityId?: string;

  /**
   * The linked lead, or the linked booking's lead.
   *
   * @generated from field: optional string linked_inquiry_id = 23;
   */
  linkedInquiryId?: string;

  /**
   * Event type of the linked lead or booking, for the row label.
   *
   * @generated from field: optional string linked_event_type = 24;
   */
  linkedEventType?: string;
};

/**
 * Describes the message cortado.v1.EmailThreadLite.
 * Use `create(EmailThreadLiteSchema)` to create a new message.
 */
export const EmailThreadLiteSchema: GenMessage<EmailThreadLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 2);

/**
 * EmailThread represents a conversation thread of email messages
 *
 * @generated from message cortado.v1.EmailThread
 */
export type EmailThread = Message<"cortado.v1.EmailThread"> & {
  /**
   * Unique identifier for the email thread
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the thread belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Subject of the email thread
   *
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * Current status of the thread
   *
   * @generated from field: cortado.v1.EmailThreadStatus status = 4;
   */
  status: EmailThreadStatus;

  /**
   * Participants in the thread
   *
   * @generated from field: repeated cortado.v1.EmailParticipant participants = 5;
   */
  participants: EmailParticipant[];

  /**
   * Inquiry ID this thread is linked to (optional)
   *
   * @generated from field: optional string inquiry_id = 6;
   */
  inquiryId?: string;

  /**
   * Contact ID this thread is linked to (optional)
   *
   * @generated from field: optional string contact_id = 7;
   */
  contactId?: string;

  /**
   * User ID the thread is assigned to (optional)
   *
   * @generated from field: optional string assigned_to = 8;
   */
  assignedTo?: string;

  /**
   * Number of messages in the thread
   *
   * @generated from field: int32 message_count = 9;
   */
  messageCount: number;

  /**
   * Timestamp of the last message (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp last_message_at = 10;
   */
  lastMessageAt?: Timestamp;

  /**
   * Direction of the last message (optional)
   *
   * @generated from field: optional cortado.v1.EmailMessageDirection last_message_direction = 11;
   */
  lastMessageDirection?: EmailMessageDirection;

  /**
   * Timestamp when this snoozed thread should reopen (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp snoozed_until = 15;
   */
  snoozedUntil?: Timestamp;

  /**
   * Messages in this thread
   *
   * @generated from field: repeated cortado.v1.Email messages = 12;
   */
  messages: Email[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;

  /**
   * Connected mailbox the thread came in on: the one that first captured it,
   * or the one Cortado first sent it from. Unset for threads that started on
   * Gmail or before connected inboxes.
   *
   * @generated from field: optional string connected_mailbox_id = 16;
   */
  connectedMailboxId?: string;

  /**
   * Address of that mailbox, for the "Came in on" label. Unset when the
   * mailbox could not be read.
   *
   * @generated from field: optional string connected_mailbox_email = 17;
   */
  connectedMailboxEmail?: string;

  /**
   * Why the thread waits in NEEDS_REVIEW, when it does. Unset when no review
   * question is open.
   *
   * @generated from field: optional cortado.v1.EmailThreadReviewReason review_reason = 18;
   */
  reviewReason?: EmailThreadReviewReason;
};

/**
 * Describes the message cortado.v1.EmailThread.
 * Use `create(EmailThreadSchema)` to create a new message.
 */
export const EmailThreadSchema: GenMessage<EmailThread> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 3);

/**
 * Email represents an email in the system
 *
 * @generated from message cortado.v1.Email
 */
export type Email = Message<"cortado.v1.Email"> & {
  /**
   * Unique identifier for the email
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the email belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Type of email (e.g., "sent", "received", "draft")
   *
   * @generated from field: string email_type = 3;
   */
  emailType: string;

  /**
   * Vendor (e.g., "gmail", "resend") (optional)
   *
   * @generated from field: optional string vendor = 4;
   */
  vendor?: string;

  /**
   * Vendor message ID (optional)
   *
   * @generated from field: optional string vendor_message_id = 5;
   */
  vendorMessageId?: string;

  /**
   * Vendor thread ID (optional)
   *
   * @generated from field: optional string vendor_thread_id = 6;
   */
  vendorThreadId?: string;

  /**
   * Subject line of the email
   *
   * @generated from field: string subject = 7;
   */
  subject: string;

  /**
   * Body of the email (optional)
   *
   * @generated from field: optional string body = 8;
   */
  body?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Delivery status of the email
   *
   * @generated from field: cortado.v1.EmailDeliveryStatus delivery_status = 11;
   */
  deliveryStatus: EmailDeliveryStatus;

  /**
   * Timestamp when email was delivered (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp delivered_at = 12;
   */
  deliveredAt?: Timestamp;

  /**
   * Timestamp when email bounced (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp bounced_at = 13;
   */
  bouncedAt?: Timestamp;

  /**
   * Reason for bounce if applicable (optional)
   *
   * @generated from field: optional string bounce_reason = 14;
   */
  bounceReason?: string;

  /**
   * Thread ID this email belongs to (optional)
   *
   * @generated from field: optional string thread_id = 15;
   */
  threadId?: string;

  /**
   * Direction of the email (inbound/outbound)
   *
   * @generated from field: cortado.v1.EmailMessageDirection direction = 16;
   */
  direction: EmailMessageDirection;

  /**
   * RFC 2822 Message-ID header for threading
   *
   * @generated from field: optional string rfc_message_id = 17;
   */
  rfcMessageId?: string;

  /**
   * RFC 2822 In-Reply-To header for threading (optional)
   *
   * @generated from field: optional string in_reply_to = 18;
   */
  inReplyTo?: string;

  /**
   * User ID who created this email (optional, for outbound)
   *
   * @generated from field: optional string created_by = 19;
   */
  createdBy?: string;

  /**
   * Status of fetching the full email body from the vendor
   *
   * @generated from field: cortado.v1.EmailBodyFetchStatusEnum body_fetch_status = 20;
   */
  bodyFetchStatus: EmailBodyFetchStatusEnum;

  /**
   * Last body fetch error, if any
   *
   * @generated from field: optional string body_fetch_error = 21;
   */
  bodyFetchError?: string;

  /**
   * Number of body fetch attempts
   *
   * @generated from field: int32 body_fetch_attempts = 22;
   */
  bodyFetchAttempts: number;

  /**
   * Timestamp of the last body fetch attempt (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp body_fetch_last_attempt_at = 23;
   */
  bodyFetchLastAttemptAt?: Timestamp;

  /**
   * Timestamp when body fetching permanently failed (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp body_fetch_failed_at = 24;
   */
  bodyFetchFailedAt?: Timestamp;

  /**
   * Set on receipt of first Resend email.opened event; subsequent opens ignored.
   *
   * @generated from field: optional google.protobuf.Timestamp opened_at = 25;
   */
  openedAt?: Timestamp;

  /**
   * Timestamp when recipient marked email as spam/complained (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp complained_at = 26;
   */
  complainedAt?: Timestamp;

  /**
   * Timestamp when email delivery was delayed by the provider (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp delivery_delayed_at = 27;
   */
  deliveryDelayedAt?: Timestamp;

  /**
   * Attachments on this email (populated when viewing thread).
   *
   * @generated from field: repeated cortado.v1.AttachmentLite attachments = 28;
   */
  attachments: AttachmentLite[];

  /**
   * RFC 2822 References header for threading (optional)
   *
   * @generated from field: optional string references_header = 29;
   */
  referencesHeader?: string;

  /**
   * Last outbound send failure reason, if any. Set only for emails delivered
   * through the outbox; lets the UI explain WHY a send failed before offering
   * RetryEmailSend.
   *
   * @generated from field: optional string last_send_error = 30;
   */
  lastSendError?: string;

  /**
   * Number of outbound send attempts made through the outbox.
   *
   * @generated from field: optional int32 send_attempts = 31;
   */
  sendAttempts?: number;

  /**
   * Sender and recipients of this message (from/to/cc, plus bcc on outbound
   * messages only). Populated by GetEmailThread; empty elsewhere unless noted
   * on the RPC.
   *
   * @generated from field: repeated cortado.v1.EmailAddress addresses = 32;
   */
  addresses: EmailAddress[];
};

/**
 * Describes the message cortado.v1.Email.
 * Use `create(EmailSchema)` to create a new message.
 */
export const EmailSchema: GenMessage<Email> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 4);

/**
 * EmailAddress represents an email address (from/to/cc/bcc)
 *
 * @generated from message cortado.v1.EmailAddress
 */
export type EmailAddress = Message<"cortado.v1.EmailAddress"> & {
  /**
   * Unique identifier for the email address record
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Email ID this address is associated with
   *
   * @generated from field: string email_id = 2;
   */
  emailId: string;

  /**
   * The actual email address
   *
   * @generated from field: string email_address = 3;
   */
  emailAddress: string;

  /**
   * Type of email address (e.g., "from", "to", "cc", "bcc")
   *
   * @generated from field: string email_address_type = 4;
   */
  emailAddressType: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * Name the address was sent with ("Anne Young" in
   * "Anne Young <anne@example.com>"). Unset when the mail named no one or
   * the address was stored before names were kept.
   *
   * @generated from field: optional string display_name = 7;
   */
  displayName?: string;
};

/**
 * Describes the message cortado.v1.EmailAddress.
 * Use `create(EmailAddressSchema)` to create a new message.
 */
export const EmailAddressSchema: GenMessage<EmailAddress> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 5);

/**
 * EmailRelation represents a relationship between an email and another entity
 *
 * @generated from message cortado.v1.EmailRelation
 */
export type EmailRelation = Message<"cortado.v1.EmailRelation"> & {
  /**
   * Unique identifier for the email relation
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Email ID
   *
   * @generated from field: string email_id = 2;
   */
  emailId: string;

  /**
   * Type of parent entity
   *
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * ID of parent entity
   *
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.EmailRelation.
 * Use `create(EmailRelationSchema)` to create a new message.
 */
export const EmailRelationSchema: GenMessage<EmailRelation> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 6);

/**
 * EmailTemplate represents an email template
 *
 * @generated from message cortado.v1.EmailTemplate
 */
export type EmailTemplate = Message<"cortado.v1.EmailTemplate"> & {
  /**
   * Unique identifier for the email template
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the template belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Name of the template
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Category of the template
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * Subject line template
   *
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * Body template
   *
   * @generated from field: string body = 6;
   */
  body: string;

  /**
   * Available variables for the template
   *
   * @generated from field: repeated string available_variables = 7;
   */
  availableVariables: string[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.EmailTemplate.
 * Use `create(EmailTemplateSchema)` to create a new message.
 */
export const EmailTemplateSchema: GenMessage<EmailTemplate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 7);

/**
 * EmailWithAddresses bundles an email with its addresses and a preview
 *
 * @generated from message cortado.v1.EmailWithAddresses
 */
export type EmailWithAddresses = Message<"cortado.v1.EmailWithAddresses"> & {
  /**
   * @generated from field: cortado.v1.Email email = 1;
   */
  email?: Email;

  /**
   * @generated from field: repeated cortado.v1.EmailAddress addresses = 2;
   */
  addresses: EmailAddress[];

  /**
   * @generated from field: string preview = 3;
   */
  preview: string;
};

/**
 * Describes the message cortado.v1.EmailWithAddresses.
 * Use `create(EmailWithAddressesSchema)` to create a new message.
 */
export const EmailWithAddressesSchema: GenMessage<EmailWithAddresses> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 8);

/**
 * EmailThreadWithMessages bundles a collapsed thread summary with its messages.
 *
 * @generated from message cortado.v1.EmailThreadWithMessages
 */
export type EmailThreadWithMessages = Message<"cortado.v1.EmailThreadWithMessages"> & {
  /**
   * @generated from field: cortado.v1.EmailThreadLite thread = 1;
   */
  thread?: EmailThreadLite;

  /**
   * @generated from field: repeated cortado.v1.EmailWithAddresses messages = 2;
   */
  messages: EmailWithAddresses[];
};

/**
 * Describes the message cortado.v1.EmailThreadWithMessages.
 * Use `create(EmailThreadWithMessagesSchema)` to create a new message.
 */
export const EmailThreadWithMessagesSchema: GenMessage<EmailThreadWithMessages> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 9);

/**
 * ListEmailsRequest retrieves a flat email history for a parent entity
 *
 * @generated from message cortado.v1.ListEmailsRequest
 */
export type ListEmailsRequest = Message<"cortado.v1.ListEmailsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 2;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListEmailsRequest.
 * Use `create(ListEmailsRequestSchema)` to create a new message.
 */
export const ListEmailsRequestSchema: GenMessage<ListEmailsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 10);

/**
 * ListEmailsResponse returns a flat email history for a parent entity
 *
 * @generated from message cortado.v1.ListEmailsResponse
 */
export type ListEmailsResponse = Message<"cortado.v1.ListEmailsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailWithAddresses emails = 1;
   */
  emails: EmailWithAddresses[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: repeated cortado.v1.EmailThreadWithMessages threads = 3;
   */
  threads: EmailThreadWithMessages[];

  /**
   * @generated from field: int32 thread_total_count = 4;
   */
  threadTotalCount: number;
};

/**
 * Describes the message cortado.v1.ListEmailsResponse.
 * Use `create(ListEmailsResponseSchema)` to create a new message.
 */
export const ListEmailsResponseSchema: GenMessage<ListEmailsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 11);

/**
 * ListEmailThreadsRequest retrieves email threads for the inbox
 *
 * @generated from message cortado.v1.ListEmailThreadsRequest
 */
export type ListEmailThreadsRequest = Message<"cortado.v1.ListEmailThreadsRequest"> & {
  /**
   * Organization ID to get threads for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by thread statuses (e.g., OPEN, CLOSED, NEEDS_REVIEW)
   *
   * @generated from field: repeated cortado.v1.EmailThreadStatus statuses = 2;
   */
  statuses: EmailThreadStatus[];

  /**
   * Optional filter by assigned user ID
   *
   * @generated from field: optional string assigned_to = 3;
   */
  assignedTo?: string;

  /**
   * Optional filter by linked inquiry ID
   *
   * @generated from field: optional string inquiry_id = 4;
   */
  inquiryId?: string;

  /**
   * Optional limit on number of threads to return (default: 50)
   *
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;

  /**
   * Optional offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 6;
   */
  offset?: number;

  /**
   * Optional field to sort by (default: last_message_at)
   *
   * @generated from field: optional string sort_by = 7;
   */
  sortBy?: string;

  /**
   * Optional sort order: "asc" or "desc" (default: desc)
   *
   * @generated from field: optional string sort_order = 8;
   */
  sortOrder?: string;

  /**
   * Optional full-text search query across subject, participants, and body
   *
   * @generated from field: string search_query = 9;
   */
  searchQuery: string;

  /**
   * Optional Inbox tab. Unspecified lists every visible thread.
   *
   * @generated from field: cortado.v1.EmailInboxView view = 10;
   */
  view: EmailInboxView;

  /**
   * Optional filter by the connected mailbox the thread came in on
   *
   * @generated from field: optional string connected_mailbox_id = 11;
   */
  connectedMailboxId?: string;

  /**
   * Only threads with a message newer than the caller's read position
   *
   * @generated from field: bool unread_only = 12;
   */
  unreadOnly: boolean;
};

/**
 * Describes the message cortado.v1.ListEmailThreadsRequest.
 * Use `create(ListEmailThreadsRequestSchema)` to create a new message.
 */
export const ListEmailThreadsRequestSchema: GenMessage<ListEmailThreadsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 12);

/**
 * EmailInboxViewCount is the size of one Inbox tab.
 *
 * @generated from message cortado.v1.EmailInboxViewCount
 */
export type EmailInboxViewCount = Message<"cortado.v1.EmailInboxViewCount"> & {
  /**
   * Threads in the tab.
   *
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * Of those, threads unread by the caller.
   *
   * @generated from field: int32 unread = 2;
   */
  unread: number;
};

/**
 * Describes the message cortado.v1.EmailInboxViewCount.
 * Use `create(EmailInboxViewCountSchema)` to create a new message.
 */
export const EmailInboxViewCountSchema: GenMessage<EmailInboxViewCount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 13);

/**
 * EmailInboxViewCounts sizes every Inbox tab in one read. Only the mailbox
 * filter applies to them; search, status and unread filters do not.
 *
 * @generated from message cortado.v1.EmailInboxViewCounts
 */
export type EmailInboxViewCounts = Message<"cortado.v1.EmailInboxViewCounts"> & {
  /**
   * @generated from field: cortado.v1.EmailInboxViewCount needs_review = 1;
   */
  needsReview?: EmailInboxViewCount;

  /**
   * @generated from field: cortado.v1.EmailInboxViewCount mine = 2;
   */
  mine?: EmailInboxViewCount;

  /**
   * @generated from field: cortado.v1.EmailInboxViewCount all = 3;
   */
  all?: EmailInboxViewCount;

  /**
   * @generated from field: cortado.v1.EmailInboxViewCount snoozed = 4;
   */
  snoozed?: EmailInboxViewCount;

  /**
   * @generated from field: cortado.v1.EmailInboxViewCount muted = 5;
   */
  muted?: EmailInboxViewCount;
};

/**
 * Describes the message cortado.v1.EmailInboxViewCounts.
 * Use `create(EmailInboxViewCountsSchema)` to create a new message.
 */
export const EmailInboxViewCountsSchema: GenMessage<EmailInboxViewCounts> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 14);

/**
 * ListEmailThreadsResponse returns email threads for the inbox
 *
 * @generated from message cortado.v1.ListEmailThreadsResponse
 */
export type ListEmailThreadsResponse = Message<"cortado.v1.ListEmailThreadsResponse"> & {
  /**
   * Lightweight threads optimized for list views
   *
   * @generated from field: repeated cortado.v1.EmailThreadLite threads = 1;
   */
  threads: EmailThreadLite[];

  /**
   * Total count of matching threads (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * Total unread inbox conversations for the current user, leaving out
   * threads they muted and threads snoozed until a future time
   *
   * @generated from field: int32 unread_count = 3;
   */
  unreadCount: number;

  /**
   * Tab sizes, set when the request names a view
   *
   * @generated from field: optional cortado.v1.EmailInboxViewCounts view_counts = 4;
   */
  viewCounts?: EmailInboxViewCounts;
};

/**
 * Describes the message cortado.v1.ListEmailThreadsResponse.
 * Use `create(ListEmailThreadsResponseSchema)` to create a new message.
 */
export const ListEmailThreadsResponseSchema: GenMessage<ListEmailThreadsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 15);

/**
 * UpdateEmailThreadRequest updates an email thread's properties
 *
 * @generated from message cortado.v1.UpdateEmailThreadRequest
 */
export type UpdateEmailThreadRequest = Message<"cortado.v1.UpdateEmailThreadRequest"> & {
  /**
   * Thread ID to update (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * New thread status (optional)
   *
   * @generated from field: optional cortado.v1.EmailThreadStatus status = 2;
   */
  status?: EmailThreadStatus;

  /**
   * User ID to assign the thread to (optional, set to empty string to unassign)
   *
   * @generated from field: optional string assigned_to = 3;
   */
  assignedTo?: string;

  /**
   * Contact ID to link the thread to (optional)
   *
   * @generated from field: optional string contact_id = 4;
   */
  contactId?: string;

  /**
   * Inquiry ID to link the thread to (optional)
   *
   * @generated from field: optional string inquiry_id = 5;
   */
  inquiryId?: string;

  /**
   * Timestamp when this snoozed thread should reopen (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp snoozed_until = 7;
   */
  snoozedUntil?: Timestamp;

  /**
   * Mute or unmute the thread for the current user only (optional). A muted
   * thread stays out of the caller's Mine and All tabs, new mail included,
   * until they unmute it.
   *
   * @generated from field: optional bool muted = 8;
   */
  muted?: boolean;

  /**
   * Field mask for partial updates
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 6;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message cortado.v1.UpdateEmailThreadRequest.
 * Use `create(UpdateEmailThreadRequestSchema)` to create a new message.
 */
export const UpdateEmailThreadRequestSchema: GenMessage<UpdateEmailThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 16);

/**
 * UpdateEmailThreadResponse returns the updated email thread
 *
 * @generated from message cortado.v1.UpdateEmailThreadResponse
 */
export type UpdateEmailThreadResponse = Message<"cortado.v1.UpdateEmailThreadResponse"> & {
  /**
   * Updated email thread
   *
   * @generated from field: cortado.v1.EmailThread thread = 1;
   */
  thread?: EmailThread;
};

/**
 * Describes the message cortado.v1.UpdateEmailThreadResponse.
 * Use `create(UpdateEmailThreadResponseSchema)` to create a new message.
 */
export const UpdateEmailThreadResponseSchema: GenMessage<UpdateEmailThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 17);

/**
 * GetEmailThreadRequest retrieves a single email thread by ID
 *
 * @generated from message cortado.v1.GetEmailThreadRequest
 */
export type GetEmailThreadRequest = Message<"cortado.v1.GetEmailThreadRequest"> & {
  /**
   * Thread ID to retrieve (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.GetEmailThreadRequest.
 * Use `create(GetEmailThreadRequestSchema)` to create a new message.
 */
export const GetEmailThreadRequestSchema: GenMessage<GetEmailThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 18);

/**
 * GetEmailThreadResponse returns the email thread with all messages
 *
 * @generated from message cortado.v1.GetEmailThreadResponse
 */
export type GetEmailThreadResponse = Message<"cortado.v1.GetEmailThreadResponse"> & {
  /**
   * Email thread with messages populated
   *
   * @generated from field: cortado.v1.EmailThread thread = 1;
   */
  thread?: EmailThread;

  /**
   * Legacy draft shape retained on its original tag for wire compatibility.
   *
   * @generated from field: optional cortado.v1.Email current_user_draft = 2 [deprecated = true];
   * @deprecated
   */
  currentUserDraft?: Email;

  /**
   * Current user's saved draft for this thread, if one exists.
   *
   * @generated from field: optional cortado.v1.EmailDraft current_user_email_draft = 3;
   */
  currentUserEmailDraft?: EmailDraft;
};

/**
 * Describes the message cortado.v1.GetEmailThreadResponse.
 * Use `create(GetEmailThreadResponseSchema)` to create a new message.
 */
export const GetEmailThreadResponseSchema: GenMessage<GetEmailThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 19);

/**
 * EmailDraft is a server-persisted, autosaved draft owned by one user.
 *
 * Two shapes share this message:
 *   - Reply draft: thread_id is set. At most one per (thread, user); the
 *     recipients and sending identity are dictated by the thread.
 *   - Compose draft: thread_id is unset. The draft carries its own recipients,
 *     sending identity, and optional entity link. A user may hold several.
 *
 * @generated from message cortado.v1.EmailDraft
 */
export type EmailDraft = Message<"cortado.v1.EmailDraft"> & {
  /**
   * Unique identifier for the draft
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the draft belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Thread this draft replies to. Unset for a new compose that has no thread yet.
   *
   * @generated from field: optional string thread_id = 10;
   */
  threadId?: string;

  /**
   * Entity the compose is about (optional; unset for an unattached compose)
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 11;
   */
  parentType?: ParentTypeEnum;

  /**
   * Entity ID the compose is about (optional; set together with parent_type)
   *
   * @generated from field: optional string parent_id = 12;
   */
  parentId?: string;

  /**
   * Email account the draft will send from (optional until the user picks one)
   *
   * @generated from field: optional string from_account_id = 13;
   */
  fromAccountId?: string;

  /**
   * Recipient email addresses
   *
   * @generated from field: repeated string to_emails = 20;
   */
  toEmails: string[];

  /**
   * CC email addresses
   *
   * @generated from field: repeated string cc_emails = 21;
   */
  ccEmails: string[];

  /**
   * BCC email addresses
   *
   * @generated from field: repeated string bcc_emails = 22;
   */
  bccEmails: string[];

  /**
   * Draft subject
   *
   * @generated from field: string subject = 23;
   */
  subject: string;

  /**
   * Draft HTML body
   *
   * @generated from field: string body = 24;
   */
  body: string;

  /**
   * Attachments staged on this draft
   *
   * @generated from field: repeated cortado.v1.AttachmentLite attachments = 25;
   */
  attachments: AttachmentLite[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * User ID that owns the draft
   *
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * Updated at timestamp (advances on every autosave)
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.EmailDraft.
 * Use `create(EmailDraftSchema)` to create a new message.
 */
export const EmailDraftSchema: GenMessage<EmailDraft> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 20);

/**
 * SaveDraftRequest saves or updates one of the current user's drafts.
 *
 * Identity resolution:
 *   1. thread_id set  -> upsert the current user's single reply draft on that thread
 *   2. draft_id set   -> update that thread-less compose draft
 *   3. neither set    -> create a new compose draft
 *
 * @generated from message cortado.v1.SaveDraftRequest
 */
export type SaveDraftRequest = Message<"cortado.v1.SaveDraftRequest"> & {
  /**
   * Organization ID the draft belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Thread ID to save a reply draft for (unset for a new compose)
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Existing draft to update (unset on the first save of a new compose)
   *
   * @generated from field: optional string draft_id = 3;
   */
  draftId?: string;

  /**
   * Entity the compose is about (compose only; ignored when thread_id is set)
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 10;
   */
  parentType?: ParentTypeEnum;

  /**
   * Entity ID the compose is about (compose only; set together with parent_type)
   *
   * @generated from field: optional string parent_id = 11;
   */
  parentId?: string;

  /**
   * Email account to send from (compose only; replies are locked to the thread identity)
   *
   * @generated from field: optional string from_account_id = 12;
   */
  fromAccountId?: string;

  /**
   * Recipient email addresses (compose only)
   *
   * @generated from field: repeated string to_emails = 13;
   */
  toEmails: string[];

  /**
   * CC email addresses
   *
   * @generated from field: repeated string cc_emails = 14;
   */
  ccEmails: string[];

  /**
   * BCC email addresses
   *
   * @generated from field: repeated string bcc_emails = 15;
   */
  bccEmails: string[];

  /**
   * Draft subject
   *
   * @generated from field: string subject = 20;
   */
  subject: string;

  /**
   * Draft HTML body
   *
   * @generated from field: string body = 21;
   */
  body: string;

  /**
   * Attachment IDs (uploaded via CreateAttachment) staged on this draft. They
   * carry over when the draft is sent. Max 10 attachments, total size <= 20 MB.
   *
   * @generated from field: repeated string attachment_ids = 22;
   */
  attachmentIds: string[];

  /**
   * Optimistic-concurrency token: the EmailDraft.updated_at the client last
   * saw. When set on an update of an existing draft_id, the server rejects the
   * save with FAILED_PRECONDITION if the stored draft has moved on — that is,
   * another tab or session saved in between. Leave unset to keep the existing
   * last-write-wins behaviour; every client that shipped before this field
   * continues to work unchanged.
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 30;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.SaveDraftRequest.
 * Use `create(SaveDraftRequestSchema)` to create a new message.
 */
export const SaveDraftRequestSchema: GenMessage<SaveDraftRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 21);

/**
 * SaveDraftResponse returns the saved draft
 *
 * @generated from message cortado.v1.SaveDraftResponse
 */
export type SaveDraftResponse = Message<"cortado.v1.SaveDraftResponse"> & {
  /**
   * Legacy draft shape retained on its original tag for wire compatibility.
   *
   * @generated from field: cortado.v1.Email draft = 1 [deprecated = true];
   * @deprecated
   */
  draft?: Email;

  /**
   * Persisted draft with compose metadata and optimistic-concurrency token.
   *
   * @generated from field: cortado.v1.EmailDraft email_draft = 2;
   */
  emailDraft?: EmailDraft;
};

/**
 * Describes the message cortado.v1.SaveDraftResponse.
 * Use `create(SaveDraftResponseSchema)` to create a new message.
 */
export const SaveDraftResponseSchema: GenMessage<SaveDraftResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 22);

/**
 * DiscardDraftRequest deletes one of the current user's drafts.
 * Supply draft_id, or thread_id to discard the current user's draft on a thread.
 *
 * @generated from message cortado.v1.DiscardDraftRequest
 */
export type DiscardDraftRequest = Message<"cortado.v1.DiscardDraftRequest"> & {
  /**
   * Organization ID the draft belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Thread ID whose current-user draft should be discarded
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Draft ID to discard (required when the draft has no thread)
   *
   * @generated from field: optional string draft_id = 3;
   */
  draftId?: string;
};

/**
 * Describes the message cortado.v1.DiscardDraftRequest.
 * Use `create(DiscardDraftRequestSchema)` to create a new message.
 */
export const DiscardDraftRequestSchema: GenMessage<DiscardDraftRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 23);

/**
 * DiscardDraftResponse returns whether a draft row was deleted
 *
 * @generated from message cortado.v1.DiscardDraftResponse
 */
export type DiscardDraftResponse = Message<"cortado.v1.DiscardDraftResponse"> & {
  /**
   * True when a draft existed and was deleted
   *
   * @generated from field: bool discarded = 1;
   */
  discarded: boolean;
};

/**
 * Describes the message cortado.v1.DiscardDraftResponse.
 * Use `create(DiscardDraftResponseSchema)` to create a new message.
 */
export const DiscardDraftResponseSchema: GenMessage<DiscardDraftResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 24);

/**
 * ListEmailDraftsRequest lists the current user's drafts so an interrupted
 * compose can be resumed from any session.
 *
 * @generated from message cortado.v1.ListEmailDraftsRequest
 */
export type ListEmailDraftsRequest = Message<"cortado.v1.ListEmailDraftsRequest"> & {
  /**
   * Organization ID to list drafts for (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * When true, return only compose drafts that have no thread. Defaults to
   * false, which returns both compose and reply drafts.
   *
   * @generated from field: optional bool composes_only = 10;
   */
  composesOnly?: boolean;

  /**
   * Restrict to drafts linked to this entity (set together with parent_id)
   *
   * @generated from field: optional cortado.v1.ParentTypeEnum parent_type = 11;
   */
  parentType?: ParentTypeEnum;

  /**
   * Restrict to drafts linked to this entity ID
   *
   * @generated from field: optional string parent_id = 12;
   */
  parentId?: string;

  /**
   * Maximum number of drafts to return (default: 50)
   *
   * @generated from field: optional int32 limit = 20;
   */
  limit?: number;

  /**
   * Offset for pagination (default: 0)
   *
   * @generated from field: optional int32 offset = 21;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListEmailDraftsRequest.
 * Use `create(ListEmailDraftsRequestSchema)` to create a new message.
 */
export const ListEmailDraftsRequestSchema: GenMessage<ListEmailDraftsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 25);

/**
 * ListEmailDraftsResponse returns the current user's drafts, newest first
 *
 * @generated from message cortado.v1.ListEmailDraftsResponse
 */
export type ListEmailDraftsResponse = Message<"cortado.v1.ListEmailDraftsResponse"> & {
  /**
   * Drafts owned by the current user, ordered by updated_at descending
   *
   * @generated from field: repeated cortado.v1.EmailDraft drafts = 1;
   */
  drafts: EmailDraft[];

  /**
   * Total count of matching drafts (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListEmailDraftsResponse.
 * Use `create(ListEmailDraftsResponseSchema)` to create a new message.
 */
export const ListEmailDraftsResponseSchema: GenMessage<ListEmailDraftsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 26);

/**
 * RetryEmailBodyFetchRequest retries fetching the body for an email
 *
 * @generated from message cortado.v1.RetryEmailBodyFetchRequest
 */
export type RetryEmailBodyFetchRequest = Message<"cortado.v1.RetryEmailBodyFetchRequest"> & {
  /**
   * Organization ID the email belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Email ID to retry fetching (required)
   *
   * @generated from field: string email_id = 2;
   */
  emailId: string;
};

/**
 * Describes the message cortado.v1.RetryEmailBodyFetchRequest.
 * Use `create(RetryEmailBodyFetchRequestSchema)` to create a new message.
 */
export const RetryEmailBodyFetchRequestSchema: GenMessage<RetryEmailBodyFetchRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 27);

/**
 * RetryEmailBodyFetchResponse returns the updated email
 *
 * @generated from message cortado.v1.RetryEmailBodyFetchResponse
 */
export type RetryEmailBodyFetchResponse = Message<"cortado.v1.RetryEmailBodyFetchResponse"> & {
  /**
   * Updated email after enqueueing or completing the retry
   *
   * @generated from field: cortado.v1.Email email = 1;
   */
  email?: Email;
};

/**
 * Describes the message cortado.v1.RetryEmailBodyFetchResponse.
 * Use `create(RetryEmailBodyFetchResponseSchema)` to create a new message.
 */
export const RetryEmailBodyFetchResponseSchema: GenMessage<RetryEmailBodyFetchResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 28);

/**
 * GetEmailAttachmentDownloadUrlRequest names one attachment on one email.
 *
 * @generated from message cortado.v1.GetEmailAttachmentDownloadUrlRequest
 */
export type GetEmailAttachmentDownloadUrlRequest = Message<"cortado.v1.GetEmailAttachmentDownloadUrlRequest"> & {
  /**
   * Organization ID the email belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Email ID the attachment is on (required)
   *
   * @generated from field: string email_id = 2;
   */
  emailId: string;

  /**
   * Attachment ID, as Email.attachments reports it (required)
   *
   * @generated from field: string attachment_id = 3;
   */
  attachmentId: string;
};

/**
 * Describes the message cortado.v1.GetEmailAttachmentDownloadUrlRequest.
 * Use `create(GetEmailAttachmentDownloadUrlRequestSchema)` to create a new message.
 */
export const GetEmailAttachmentDownloadUrlRequestSchema: GenMessage<GetEmailAttachmentDownloadUrlRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 29);

/**
 * GetEmailAttachmentDownloadUrlResponse carries a URL valid for a few minutes.
 *
 * @generated from message cortado.v1.GetEmailAttachmentDownloadUrlResponse
 */
export type GetEmailAttachmentDownloadUrlResponse = Message<"cortado.v1.GetEmailAttachmentDownloadUrlResponse"> & {
  /**
   * @generated from field: string download_url = 1;
   */
  downloadUrl: string;
};

/**
 * Describes the message cortado.v1.GetEmailAttachmentDownloadUrlResponse.
 * Use `create(GetEmailAttachmentDownloadUrlResponseSchema)` to create a new message.
 */
export const GetEmailAttachmentDownloadUrlResponseSchema: GenMessage<GetEmailAttachmentDownloadUrlResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 30);

/**
 * RetryEmailSendRequest restarts delivery for a queued or failed outbound email
 *
 * @generated from message cortado.v1.RetryEmailSendRequest
 */
export type RetryEmailSendRequest = Message<"cortado.v1.RetryEmailSendRequest"> & {
  /**
   * Organization ID the email belongs to (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Email ID to retry sending (required)
   *
   * @generated from field: string email_id = 2;
   */
  emailId: string;
};

/**
 * Describes the message cortado.v1.RetryEmailSendRequest.
 * Use `create(RetryEmailSendRequestSchema)` to create a new message.
 */
export const RetryEmailSendRequestSchema: GenMessage<RetryEmailSendRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 31);

/**
 * RetryEmailSendResponse returns the updated email
 *
 * @generated from message cortado.v1.RetryEmailSendResponse
 */
export type RetryEmailSendResponse = Message<"cortado.v1.RetryEmailSendResponse"> & {
  /**
   * Updated email after the delivery workflow was restarted
   *
   * @generated from field: cortado.v1.Email email = 1;
   */
  email?: Email;
};

/**
 * Describes the message cortado.v1.RetryEmailSendResponse.
 * Use `create(RetryEmailSendResponseSchema)` to create a new message.
 */
export const RetryEmailSendResponseSchema: GenMessage<RetryEmailSendResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 32);

/**
 * ReplyToThreadRequest sends a reply within an existing email thread
 *
 * @generated from message cortado.v1.ReplyToThreadRequest
 */
export type ReplyToThreadRequest = Message<"cortado.v1.ReplyToThreadRequest"> & {
  /**
   * Thread ID to reply to (required)
   *
   * @generated from field: string thread_id = 1;
   */
  threadId: string;

  /**
   * Connected mailbox to send from (a ConnectedMailbox id). Optional: blank
   * sends from the caller's own mailbox, else the org default. A mailbox the
   * caller may not send as, or one that is not active, is rejected. It need
   * not be the mailbox the thread came in on.
   *
   * @generated from field: string from_account_id = 2;
   */
  fromAccountId: string;

  /**
   * HTML body of the reply (required)
   *
   * @generated from field: string body_html = 3;
   */
  bodyHtml: string;

  /**
   * Plain text body (optional, auto-generated from HTML if not provided)
   *
   * @generated from field: optional string body_text = 4;
   */
  bodyText?: string;

  /**
   * CC email addresses (optional)
   *
   * @generated from field: repeated string cc_emails = 5;
   */
  ccEmails: string[];

  /**
   * Attachment IDs (uploaded via CreateAttachment with parent_type=INQUIRY) to include with this email. Max 10 attachments, total size <= 20 MB.
   *
   * @generated from field: repeated string attachment_ids = 6;
   */
  attachmentIds: string[];

  /**
   * Attachment library IDs to include with this reply (org-library attachments).
   *
   * @generated from field: repeated string library_attachment_ids = 7;
   */
  libraryAttachmentIds: string[];

  /**
   * BCC email addresses (optional)
   *
   * @generated from field: repeated string bcc_emails = 8;
   */
  bccEmails: string[];

  /**
   * Draft this reply was composed in, if any. The server promotes that draft
   * row to the sent message instead of leaving it behind.
   *
   * @generated from field: optional string draft_id = 9;
   */
  draftId?: string;

  /**
   * Client-generated idempotency key (UUID). Reuse it across retries of the
   * same reply so a double-click or a transport retry sends one email. Omit it
   * and the server generates one, which gives no double-submit protection.
   *
   * @generated from field: optional string idempotency_key = 10;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.ReplyToThreadRequest.
 * Use `create(ReplyToThreadRequestSchema)` to create a new message.
 */
export const ReplyToThreadRequestSchema: GenMessage<ReplyToThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 33);

/**
 * ReplyToThreadResponse returns the updated thread and new message
 *
 * @generated from message cortado.v1.ReplyToThreadResponse
 */
export type ReplyToThreadResponse = Message<"cortado.v1.ReplyToThreadResponse"> & {
  /**
   * Updated email thread with the new message
   *
   * @generated from field: cortado.v1.EmailThread thread = 1;
   */
  thread?: EmailThread;

  /**
   * The newly sent email message
   *
   * @generated from field: cortado.v1.Email message = 2;
   */
  message?: Email;
};

/**
 * Describes the message cortado.v1.ReplyToThreadResponse.
 * Use `create(ReplyToThreadResponseSchema)` to create a new message.
 */
export const ReplyToThreadResponseSchema: GenMessage<ReplyToThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 34);

/**
 * EmailTemplateTextSlot represents a customizable text slot within an email template
 *
 * @generated from message cortado.v1.EmailTemplateTextSlot
 */
export type EmailTemplateTextSlot = Message<"cortado.v1.EmailTemplateTextSlot"> & {
  /**
   * Key identifying the slot (e.g., "greeting", "mainMessage")
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Human-readable label for the slot
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Description of what this slot is for
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Default value for this slot (with Go template variables like {{.CustomerName}})
   *
   * @generated from field: string default_value = 4;
   */
  defaultValue: string;

  /**
   * Custom value set by the organization (optional, empty means use default)
   *
   * @generated from field: optional string custom_value = 5;
   */
  customValue?: string;

  /**
   * Whether this slot supports sanitized rich-text HTML editing
   *
   * @generated from field: bool rich_text = 6;
   */
  richText: boolean;
};

/**
 * Describes the message cortado.v1.EmailTemplateTextSlot.
 * Use `create(EmailTemplateTextSlotSchema)` to create a new message.
 */
export const EmailTemplateTextSlotSchema: GenMessage<EmailTemplateTextSlot> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 35);

/**
 * SystemEmailTemplateOverride represents an organization's customization of a system email template
 *
 * @generated from message cortado.v1.SystemEmailTemplateOverride
 */
export type SystemEmailTemplateOverride = Message<"cortado.v1.SystemEmailTemplateOverride"> & {
  /**
   * Unique identifier for this override record
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the override belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Type of system email template being overridden
   *
   * @generated from field: cortado.v1.SystemEmailTemplateType template_type = 3;
   */
  templateType: SystemEmailTemplateType;

  /**
   * Custom subject line (optional, empty means use default)
   *
   * @generated from field: optional string custom_subject = 4;
   */
  customSubject?: string;

  /**
   * Text slots available for this template with their default and custom values
   *
   * @generated from field: repeated cortado.v1.EmailTemplateTextSlot text_slots = 5;
   */
  textSlots: EmailTemplateTextSlot[];

  /**
   * Default subject line for reference
   *
   * @generated from field: string default_subject = 6;
   */
  defaultSubject: string;

  /**
   * Available variables that can be used in subject and text slots
   *
   * @generated from field: repeated string available_variables = 7;
   */
  availableVariables: string[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.SystemEmailTemplateOverride.
 * Use `create(SystemEmailTemplateOverrideSchema)` to create a new message.
 */
export const SystemEmailTemplateOverrideSchema: GenMessage<SystemEmailTemplateOverride> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 36);

/**
 * ListSystemEmailTemplatesRequest retrieves all system email templates for an organization
 *
 * @generated from message cortado.v1.ListSystemEmailTemplatesRequest
 */
export type ListSystemEmailTemplatesRequest = Message<"cortado.v1.ListSystemEmailTemplatesRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListSystemEmailTemplatesRequest.
 * Use `create(ListSystemEmailTemplatesRequestSchema)` to create a new message.
 */
export const ListSystemEmailTemplatesRequestSchema: GenMessage<ListSystemEmailTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 37);

/**
 * ListSystemEmailTemplatesResponse returns all system email templates with their current state
 *
 * @generated from message cortado.v1.ListSystemEmailTemplatesResponse
 */
export type ListSystemEmailTemplatesResponse = Message<"cortado.v1.ListSystemEmailTemplatesResponse"> & {
  /**
   * All system email templates with their defaults and any customizations
   *
   * @generated from field: repeated cortado.v1.SystemEmailTemplateOverride templates = 1;
   */
  templates: SystemEmailTemplateOverride[];
};

/**
 * Describes the message cortado.v1.ListSystemEmailTemplatesResponse.
 * Use `create(ListSystemEmailTemplatesResponseSchema)` to create a new message.
 */
export const ListSystemEmailTemplatesResponseSchema: GenMessage<ListSystemEmailTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 38);

/**
 * GetSystemEmailTemplateRequest retrieves a specific system email template
 *
 * @generated from message cortado.v1.GetSystemEmailTemplateRequest
 */
export type GetSystemEmailTemplateRequest = Message<"cortado.v1.GetSystemEmailTemplateRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Template type to retrieve (required)
   *
   * @generated from field: cortado.v1.SystemEmailTemplateType template_type = 2;
   */
  templateType: SystemEmailTemplateType;
};

/**
 * Describes the message cortado.v1.GetSystemEmailTemplateRequest.
 * Use `create(GetSystemEmailTemplateRequestSchema)` to create a new message.
 */
export const GetSystemEmailTemplateRequestSchema: GenMessage<GetSystemEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 39);

/**
 * GetSystemEmailTemplateResponse returns a system email template with its current state
 *
 * @generated from message cortado.v1.GetSystemEmailTemplateResponse
 */
export type GetSystemEmailTemplateResponse = Message<"cortado.v1.GetSystemEmailTemplateResponse"> & {
  /**
   * System email template with defaults and any customizations
   *
   * @generated from field: cortado.v1.SystemEmailTemplateOverride template = 1;
   */
  template?: SystemEmailTemplateOverride;
};

/**
 * Describes the message cortado.v1.GetSystemEmailTemplateResponse.
 * Use `create(GetSystemEmailTemplateResponseSchema)` to create a new message.
 */
export const GetSystemEmailTemplateResponseSchema: GenMessage<GetSystemEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 40);

/**
 * UpdateSystemEmailTemplateRequest updates a system email template's customizations
 *
 * @generated from message cortado.v1.UpdateSystemEmailTemplateRequest
 */
export type UpdateSystemEmailTemplateRequest = Message<"cortado.v1.UpdateSystemEmailTemplateRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Template type to update (required)
   *
   * @generated from field: cortado.v1.SystemEmailTemplateType template_type = 2;
   */
  templateType: SystemEmailTemplateType;

  /**
   * Custom subject line (optional, set to empty to use default)
   *
   * @generated from field: optional string custom_subject = 3;
   */
  customSubject?: string;

  /**
   * Custom text slot values (key -> custom_value mapping)
   *
   * @generated from field: map<string, string> custom_text_slots = 4;
   */
  customTextSlots: { [key: string]: string };
};

/**
 * Describes the message cortado.v1.UpdateSystemEmailTemplateRequest.
 * Use `create(UpdateSystemEmailTemplateRequestSchema)` to create a new message.
 */
export const UpdateSystemEmailTemplateRequestSchema: GenMessage<UpdateSystemEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 41);

/**
 * UpdateSystemEmailTemplateResponse returns the updated system email template
 *
 * @generated from message cortado.v1.UpdateSystemEmailTemplateResponse
 */
export type UpdateSystemEmailTemplateResponse = Message<"cortado.v1.UpdateSystemEmailTemplateResponse"> & {
  /**
   * Updated system email template
   *
   * @generated from field: cortado.v1.SystemEmailTemplateOverride template = 1;
   */
  template?: SystemEmailTemplateOverride;
};

/**
 * Describes the message cortado.v1.UpdateSystemEmailTemplateResponse.
 * Use `create(UpdateSystemEmailTemplateResponseSchema)` to create a new message.
 */
export const UpdateSystemEmailTemplateResponseSchema: GenMessage<UpdateSystemEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 42);

/**
 * ResetSystemEmailTemplateRequest resets a system email template to defaults
 *
 * @generated from message cortado.v1.ResetSystemEmailTemplateRequest
 */
export type ResetSystemEmailTemplateRequest = Message<"cortado.v1.ResetSystemEmailTemplateRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Template type to reset (required)
   *
   * @generated from field: cortado.v1.SystemEmailTemplateType template_type = 2;
   */
  templateType: SystemEmailTemplateType;
};

/**
 * Describes the message cortado.v1.ResetSystemEmailTemplateRequest.
 * Use `create(ResetSystemEmailTemplateRequestSchema)` to create a new message.
 */
export const ResetSystemEmailTemplateRequestSchema: GenMessage<ResetSystemEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 43);

/**
 * ResetSystemEmailTemplateResponse confirms the reset
 *
 * @generated from message cortado.v1.ResetSystemEmailTemplateResponse
 */
export type ResetSystemEmailTemplateResponse = Message<"cortado.v1.ResetSystemEmailTemplateResponse"> & {
  /**
   * System email template with defaults restored
   *
   * @generated from field: cortado.v1.SystemEmailTemplateOverride template = 1;
   */
  template?: SystemEmailTemplateOverride;
};

/**
 * Describes the message cortado.v1.ResetSystemEmailTemplateResponse.
 * Use `create(ResetSystemEmailTemplateResponseSchema)` to create a new message.
 */
export const ResetSystemEmailTemplateResponseSchema: GenMessage<ResetSystemEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 44);

/**
 * PreviewSystemEmailTemplateRequest generates a preview of a system email template
 *
 * @generated from message cortado.v1.PreviewSystemEmailTemplateRequest
 */
export type PreviewSystemEmailTemplateRequest = Message<"cortado.v1.PreviewSystemEmailTemplateRequest"> & {
  /**
   * Organization ID (required)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Template type to preview (required)
   *
   * @generated from field: cortado.v1.SystemEmailTemplateType template_type = 2;
   */
  templateType: SystemEmailTemplateType;

  /**
   * Custom subject line to preview (optional, uses current/default if not provided)
   *
   * @generated from field: optional string custom_subject = 3;
   */
  customSubject?: string;

  /**
   * Custom text slot values to preview (optional, uses current/defaults if not provided)
   *
   * @generated from field: map<string, string> custom_text_slots = 4;
   */
  customTextSlots: { [key: string]: string };
};

/**
 * Describes the message cortado.v1.PreviewSystemEmailTemplateRequest.
 * Use `create(PreviewSystemEmailTemplateRequestSchema)` to create a new message.
 */
export const PreviewSystemEmailTemplateRequestSchema: GenMessage<PreviewSystemEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 45);

/**
 * PreviewSystemEmailTemplateResponse returns a rendered preview
 *
 * @generated from message cortado.v1.PreviewSystemEmailTemplateResponse
 */
export type PreviewSystemEmailTemplateResponse = Message<"cortado.v1.PreviewSystemEmailTemplateResponse"> & {
  /**
   * Rendered subject line with sample data
   *
   * @generated from field: string rendered_subject = 1;
   */
  renderedSubject: string;

  /**
   * Rendered HTML body with sample data
   *
   * @generated from field: string rendered_html = 2;
   */
  renderedHtml: string;
};

/**
 * Describes the message cortado.v1.PreviewSystemEmailTemplateResponse.
 * Use `create(PreviewSystemEmailTemplateResponseSchema)` to create a new message.
 */
export const PreviewSystemEmailTemplateResponseSchema: GenMessage<PreviewSystemEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 46);

/**
 * ConnectedMailbox is an operator's own mailbox connected to Cortado
 * (user-facing name: Connected inbox).
 *
 * @generated from message cortado.v1.ConnectedMailbox
 */
export type ConnectedMailbox = Message<"cortado.v1.ConnectedMailbox"> & {
  /**
   * Unique identifier
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization the mailbox belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * User who connected the mailbox
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Display name of the user who connected the mailbox
   *
   * @generated from field: string user_name = 4;
   */
  userName: string;

  /**
   * The mailbox address
   *
   * @generated from field: string email_address = 5;
   */
  emailAddress: string;

  /**
   * Display name of the mailbox (may be empty)
   *
   * @generated from field: string display_name = 6;
   */
  displayName: string;

  /**
   * Provider kind
   *
   * @generated from field: cortado.v1.ConnectedMailboxProvider provider = 7;
   */
  provider: ConnectedMailboxProvider;

  /**
   * Connection status
   *
   * @generated from field: cortado.v1.ConnectedMailboxStatus status = 8;
   */
  status: ConnectedMailboxStatus;

  /**
   * Whether automated mail sends from this mailbox (one per organization)
   *
   * @generated from field: bool is_org_default = 9;
   */
  isOrgDefault: boolean;

  /**
   * When the mailbox was connected
   *
   * @generated from field: google.protobuf.Timestamp connected_at = 10;
   */
  connectedAt?: Timestamp;

  /**
   * When the mailbox was disconnected, if it was
   *
   * @generated from field: optional google.protobuf.Timestamp disconnected_at = 11;
   */
  disconnectedAt?: Timestamp;

  /**
   * Whether the caller may send as this mailbox: it is theirs, the org
   * default, or shared with them. Set by ListSendableMailboxes only.
   *
   * @generated from field: bool caller_can_send = 12;
   */
  callerCanSend: boolean;
};

/**
 * Describes the message cortado.v1.ConnectedMailbox.
 * Use `create(ConnectedMailboxSchema)` to create a new message.
 */
export const ConnectedMailboxSchema: GenMessage<ConnectedMailbox> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 47);

/**
 * EmailCaptureSettings are an organization's connected-inbox capture options.
 *
 * @generated from message cortado.v1.EmailCaptureSettings
 */
export type EmailCaptureSettings = Message<"cortado.v1.EmailCaptureSettings"> & {
  /**
   * When on, mail from a company's domain (Company.domain) is captured and
   * linked to that company while it has open inquiries or bookings, even
   * when the sender is not a contact. Public mail providers never count.
   *
   * @generated from field: bool match_company_domains = 20;
   */
  matchCompanyDomains: boolean;
};

/**
 * Describes the message cortado.v1.EmailCaptureSettings.
 * Use `create(EmailCaptureSettingsSchema)` to create a new message.
 */
export const EmailCaptureSettingsSchema: GenMessage<EmailCaptureSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 48);

/**
 * EmailCaptureExclusion is an address or domain whose mail the connected
 * inbox never captures (the "Never capture" list). Org-wide entries apply to
 * every mailbox; a mailbox entry applies to that mailbox only. The team's own
 * addresses are always excluded and are not listed.
 *
 * @generated from message cortado.v1.EmailCaptureExclusion
 */
export type EmailCaptureExclusion = Message<"cortado.v1.EmailCaptureExclusion"> & {
  /**
   * Unique identifier
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization the entry belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Mailbox the entry applies to; empty for an org-wide entry
   *
   * @generated from field: string mailbox_id = 10;
   */
  mailboxId: string;

  /**
   * Address of that mailbox; empty for an org-wide entry
   *
   * @generated from field: string mailbox_email = 11;
   */
  mailboxEmail: string;

  /**
   * The address or domain, lowercased
   *
   * @generated from field: string pattern = 20;
   */
  pattern: string;

  /**
   * Whether pattern is an address or a domain
   *
   * @generated from field: cortado.v1.EmailCaptureExclusionKindEnum kind = 21;
   */
  kind: EmailCaptureExclusionKindEnum;

  /**
   * When the entry was added
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * User who added the entry
   *
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * Display name of that user
   *
   * @generated from field: string created_by_name = 62;
   */
  createdByName: string;
};

/**
 * Describes the message cortado.v1.EmailCaptureExclusion.
 * Use `create(EmailCaptureExclusionSchema)` to create a new message.
 */
export const EmailCaptureExclusionSchema: GenMessage<EmailCaptureExclusion> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 49);

/**
 * EmailSenderSuggestion is received mail from a sender who is not a contact,
 * kept as a "Not in Cortado" suggestion. Several messages from one sender to
 * one mailbox collapse into one suggestion. Only metadata is kept: no body
 * and no attachments.
 *
 * @generated from message cortado.v1.EmailSenderSuggestion
 */
export type EmailSenderSuggestion = Message<"cortado.v1.EmailSenderSuggestion"> & {
  /**
   * Unique identifier
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization the suggestion belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Mailbox the mail arrived in
   *
   * @generated from field: string mailbox_id = 10;
   */
  mailboxId: string;

  /**
   * Address of that mailbox
   *
   * @generated from field: string mailbox_email = 11;
   */
  mailboxEmail: string;

  /**
   * The sender's address, lowercased
   *
   * @generated from field: string sender_email = 20;
   */
  senderEmail: string;

  /**
   * The sender's display name, when the mail carried one
   *
   * @generated from field: string sender_name = 21;
   */
  senderName: string;

  /**
   * Subject of the latest message
   *
   * @generated from field: string subject = 22;
   */
  subject: string;

  /**
   * First 200 characters of the latest message
   *
   * @generated from field: string preview = 23;
   */
  preview: string;

  /**
   * How many messages the sender sent to the mailbox
   *
   * @generated from field: int32 message_count = 24;
   */
  messageCount: number;

  /**
   * When the latest message arrived
   *
   * @generated from field: google.protobuf.Timestamp received_at = 60;
   */
  receivedAt?: Timestamp;

  /**
   * When the suggestion expires unless someone acts on it
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 61;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.EmailSenderSuggestion.
 * Use `create(EmailSenderSuggestionSchema)` to create a new message.
 */
export const EmailSenderSuggestionSchema: GenMessage<EmailSenderSuggestion> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 50);

/**
 * MailboxSendAccess lets a teammate send as a connected mailbox that isn't
 * theirs. The owner and, for the org default, everyone with Manage
 * Communications need no grant.
 *
 * @generated from message cortado.v1.MailboxSendAccess
 */
export type MailboxSendAccess = Message<"cortado.v1.MailboxSendAccess"> & {
  /**
   * Mailbox the grant is for
   *
   * @generated from field: string mailbox_id = 1;
   */
  mailboxId: string;

  /**
   * User who may send as the mailbox
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Display name of that user
   *
   * @generated from field: string user_name = 3;
   */
  userName: string;

  /**
   * Email address of that user
   *
   * @generated from field: string user_email = 4;
   */
  userEmail: string;

  /**
   * User who granted the access
   *
   * @generated from field: string granted_by = 10;
   */
  grantedBy: string;

  /**
   * When the access was granted
   *
   * @generated from field: google.protobuf.Timestamp granted_at = 11;
   */
  grantedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.MailboxSendAccess.
 * Use `create(MailboxSendAccessSchema)` to create a new message.
 */
export const MailboxSendAccessSchema: GenMessage<MailboxSendAccess> = /*@__PURE__*/
  messageDesc(file_cortado_v1_emails, 51);

/**
 * EmailDeliveryStatus represents the delivery status of an email
 *
 * @generated from enum cortado.v1.EmailDeliveryStatus
 */
export enum EmailDeliveryStatus {
  /**
   * Default/unknown status
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Email is pending delivery
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Email was sent to the mail server
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_SENT = 2;
   */
  SENT = 2,

  /**
   * Email was delivered to the recipient
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_DELIVERED = 3;
   */
  DELIVERED = 3,

  /**
   * Email bounced (hard or soft bounce)
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_BOUNCED = 4;
   */
  BOUNCED = 4,

  /**
   * Recipient marked email as spam
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_COMPLAINED = 5;
   */
  COMPLAINED = 5,

  /**
   * Email delivery failed
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_FAILED = 6;
   */
  FAILED = 6,

  /**
   * Email was suppressed (recipient is on the suppression list)
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_SUPPRESSED = 7;
   */
  SUPPRESSED = 7,

  /**
   * Gmail send outcome is unconfirmed (transport error, deadline, or 5xx
   * after a possibly-successful call). Terminal, never retryable, never
   * re-claimable — retrying risks a duplicate in the customer's inbox.
   *
   * @generated from enum value: EMAIL_DELIVERY_STATUS_UNCERTAIN = 8;
   */
  UNCERTAIN = 8,
}

/**
 * Describes the enum cortado.v1.EmailDeliveryStatus.
 */
export const EmailDeliveryStatusSchema: GenEnum<EmailDeliveryStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 0);

/**
 * EmailSuppressionReason represents why an email address is on the suppression list
 *
 * @generated from enum cortado.v1.EmailSuppressionReason
 */
export enum EmailSuppressionReason {
  /**
   * Default/unknown reason
   *
   * @generated from enum value: EMAIL_SUPPRESSION_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Recipient address had a hard bounce
   *
   * @generated from enum value: EMAIL_SUPPRESSION_REASON_HARD_BOUNCE = 1;
   */
  HARD_BOUNCE = 1,

  /**
   * Recipient marked an email as spam/complained
   *
   * @generated from enum value: EMAIL_SUPPRESSION_REASON_COMPLAINT = 2;
   */
  COMPLAINT = 2,

  /**
   * Manually added by an organization user
   *
   * @generated from enum value: EMAIL_SUPPRESSION_REASON_MANUAL = 3;
   */
  MANUAL = 3,
}

/**
 * Describes the enum cortado.v1.EmailSuppressionReason.
 */
export const EmailSuppressionReasonSchema: GenEnum<EmailSuppressionReason> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 1);

/**
 * EmailThreadStatus represents the status of an email thread
 *
 * @generated from enum cortado.v1.EmailThreadStatus
 */
export enum EmailThreadStatus {
  /**
   * Default/unknown status
   *
   * @generated from enum value: EMAIL_THREAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Thread is open and active
   *
   * @generated from enum value: EMAIL_THREAD_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * Thread has been closed
   *
   * @generated from enum value: EMAIL_THREAD_STATUS_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * Thread is hidden until its snooze expires
   *
   * @generated from enum value: EMAIL_THREAD_STATUS_SNOOZED = 3;
   */
  SNOOZED = 3,

  /**
   * Thread needs review/triage (used for new inbound emails)
   *
   * @generated from enum value: EMAIL_THREAD_STATUS_NEEDS_REVIEW = 4;
   */
  NEEDS_REVIEW = 4,
}

/**
 * Describes the enum cortado.v1.EmailThreadStatus.
 */
export const EmailThreadStatusSchema: GenEnum<EmailThreadStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 2);

/**
 * EmailThreadReviewReason says why a thread waits in NEEDS_REVIEW.
 *
 * @generated from enum cortado.v1.EmailThreadReviewReason
 */
export enum EmailThreadReviewReason {
  /**
   * No review question is open.
   *
   * @generated from enum value: EMAIL_THREAD_REVIEW_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The contact has several open leads or bookings; a person picks which one
   * the conversation is about (ListEmailThreadEntityCandidates).
   *
   * @generated from enum value: EMAIL_THREAD_REVIEW_REASON_AMBIGUOUS_ENTITY = 1;
   */
  AMBIGUOUS_ENTITY = 1,

  /**
   * Reserved: the conversation has no record to link to.
   *
   * @generated from enum value: EMAIL_THREAD_REVIEW_REASON_NO_ENTITY = 2;
   */
  NO_ENTITY = 2,

  /**
   * Reserved: the sender is not a contact yet.
   *
   * @generated from enum value: EMAIL_THREAD_REVIEW_REASON_UNKNOWN_SENDER = 3;
   */
  UNKNOWN_SENDER = 3,
}

/**
 * Describes the enum cortado.v1.EmailThreadReviewReason.
 */
export const EmailThreadReviewReasonSchema: GenEnum<EmailThreadReviewReason> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 3);

/**
 * EmailInboxView picks one tab of the Inbox page. Snoozed threads (until
 * their time passes or a new message arrives) and threads the caller muted are
 * left out of MINE and ALL; they are listed under SNOOZED and MUTED instead.
 *
 * @generated from enum cortado.v1.EmailInboxView
 */
export enum EmailInboxView {
  /**
   * No view filter: every visible thread, hidden or not (the request's other
   * filters still apply).
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Threads waiting in NEEDS_REVIEW (a lead or booking to pick, or none).
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_NEEDS_REVIEW = 1;
   */
  NEEDS_REVIEW = 1,

  /**
   * Threads assigned to the caller, or linked to a lead assigned to the caller
   * (a booking counts through its lead).
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_MINE = 2;
   */
  MINE = 2,

  /**
   * Every thread in the organization's inbox.
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_ALL = 3;
   */
  ALL = 3,

  /**
   * Threads snoozed until a future time.
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_SNOOZED = 4;
   */
  SNOOZED = 4,

  /**
   * Threads the caller muted.
   *
   * @generated from enum value: EMAIL_INBOX_VIEW_MUTED = 5;
   */
  MUTED = 5,
}

/**
 * Describes the enum cortado.v1.EmailInboxView.
 */
export const EmailInboxViewSchema: GenEnum<EmailInboxView> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 4);

/**
 * EmailMessageDirection represents the direction of an email message
 *
 * @generated from enum cortado.v1.EmailMessageDirection
 */
export enum EmailMessageDirection {
  /**
   * Default/unknown direction
   *
   * @generated from enum value: EMAIL_MESSAGE_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Inbound email received from external party
   *
   * @generated from enum value: EMAIL_MESSAGE_DIRECTION_INBOUND = 1;
   */
  INBOUND = 1,

  /**
   * Outbound email sent to external party
   *
   * @generated from enum value: EMAIL_MESSAGE_DIRECTION_OUTBOUND = 2;
   */
  OUTBOUND = 2,
}

/**
 * Describes the enum cortado.v1.EmailMessageDirection.
 */
export const EmailMessageDirectionSchema: GenEnum<EmailMessageDirection> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 5);

/**
 * SystemEmailTemplateType represents the type of system email template
 *
 * @generated from enum cortado.v1.SystemEmailTemplateType
 */
export enum SystemEmailTemplateType {
  /**
   * Default/unknown type
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Confirmation email sent to customer after inquiry submission
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_NEW_INQUIRY = 1;
   */
  NEW_INQUIRY = 1,

  /**
   * Email sent when a quote is delivered to customer
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_QUOTE_SENT = 3;
   */
  QUOTE_SENT = 3,

  /**
   * Email sent when an invoice is delivered to customer
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_INVOICE_SENT = 4;
   */
  INVOICE_SENT = 4,

  /**
   * Payment receipt confirmation email
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_PAYMENT_RECEIPT = 5;
   */
  PAYMENT_RECEIPT = 5,

  /**
   * ACH payment processing notification
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_PAYMENT_PROCESSING = 6;
   */
  PAYMENT_PROCESSING = 6,

  /**
   * Payment failure notification
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_PAYMENT_FAILED = 7;
   */
  PAYMENT_FAILED = 7,

  /**
   * Refund processed confirmation
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_REFUND_PROCESSED = 8;
   */
  REFUND_PROCESSED = 8,

  /**
   * Notification sent to an organization user for a new shared inbox thread
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_INBOX_NEW_THREAD_NOTIFICATION = 9;
   */
  INBOX_NEW_THREAD_NOTIFICATION = 9,

  /**
   * Notification sent to an organization user for a shared inbox reply
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_INBOX_REPLY_NOTIFICATION = 10;
   */
  INBOX_REPLY_NOTIFICATION = 10,

  /**
   * Confirmation sent to an organization user after replying by email
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_REPLY_CONFIRMATION = 11;
   */
  REPLY_CONFIRMATION = 11,

  /**
   * Fresh customer portal link requested from an expired link
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_RESEND_LINK = 12;
   */
  RESEND_LINK = 12,

  /**
   * ACH microdeposit verification required before payment can complete
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_ACH_VERIFICATION_REQUIRED = 13;
   */
  ACH_VERIFICATION_REQUIRED = 13,

  /**
   * Notification that a previously initiated refund failed
   *
   * @generated from enum value: SYSTEM_EMAIL_TEMPLATE_TYPE_REFUND_FAILED = 14;
   */
  REFUND_FAILED = 14,
}

/**
 * Describes the enum cortado.v1.SystemEmailTemplateType.
 */
export const SystemEmailTemplateTypeSchema: GenEnum<SystemEmailTemplateType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 6);

/**
 * ConnectedMailboxProvider is the kind of mailbox connected through Nylas.
 *
 * @generated from enum cortado.v1.ConnectedMailboxProvider
 */
export enum ConnectedMailboxProvider {
  /**
   * Default/unknown provider
   *
   * @generated from enum value: CONNECTED_MAILBOX_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Google Workspace or Gmail
   *
   * @generated from enum value: CONNECTED_MAILBOX_PROVIDER_GOOGLE = 1;
   */
  GOOGLE = 1,

  /**
   * Microsoft 365 or Outlook
   *
   * @generated from enum value: CONNECTED_MAILBOX_PROVIDER_MICROSOFT = 2;
   */
  MICROSOFT = 2,

  /**
   * Any other provider over IMAP
   *
   * @generated from enum value: CONNECTED_MAILBOX_PROVIDER_IMAP = 3;
   */
  IMAP = 3,
}

/**
 * Describes the enum cortado.v1.ConnectedMailboxProvider.
 */
export const ConnectedMailboxProviderSchema: GenEnum<ConnectedMailboxProvider> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 7);

/**
 * ConnectedMailboxStatus is the health of a connected mailbox.
 *
 * @generated from enum cortado.v1.ConnectedMailboxStatus
 */
export enum ConnectedMailboxStatus {
  /**
   * Default/unknown status
   *
   * @generated from enum value: CONNECTED_MAILBOX_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Connected and working
   *
   * @generated from enum value: CONNECTED_MAILBOX_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * The connection expired; the owner must reconnect
   *
   * @generated from enum value: CONNECTED_MAILBOX_STATUS_NEEDS_RECONNECT = 2;
   */
  NEEDS_RECONNECT = 2,

  /**
   * Disconnected; kept for history
   *
   * @generated from enum value: CONNECTED_MAILBOX_STATUS_DISCONNECTED = 3;
   */
  DISCONNECTED = 3,
}

/**
 * Describes the enum cortado.v1.ConnectedMailboxStatus.
 */
export const ConnectedMailboxStatusSchema: GenEnum<ConnectedMailboxStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 8);

/**
 * EmailCaptureExclusionKindEnum says what an exclusion pattern matches.
 *
 * @generated from enum cortado.v1.EmailCaptureExclusionKindEnum
 */
export enum EmailCaptureExclusionKindEnum {
  /**
   * @generated from enum value: EMAIL_CAPTURE_EXCLUSION_KIND_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * One exact address, like accountant@firm.com
   *
   * @generated from enum value: EMAIL_CAPTURE_EXCLUSION_KIND_ENUM_ADDRESS = 1;
   */
  ADDRESS = 1,

  /**
   * Every address at one domain, like firm.com
   *
   * @generated from enum value: EMAIL_CAPTURE_EXCLUSION_KIND_ENUM_DOMAIN = 2;
   */
  DOMAIN = 2,
}

/**
 * Describes the enum cortado.v1.EmailCaptureExclusionKindEnum.
 */
export const EmailCaptureExclusionKindEnumSchema: GenEnum<EmailCaptureExclusionKindEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 9);

/**
 * EmailSenderSuggestionActionEnum is what to do with a suggestion.
 *
 * @generated from enum cortado.v1.EmailSenderSuggestionActionEnum
 */
export enum EmailSenderSuggestionActionEnum {
  /**
   * @generated from enum value: EMAIL_SENDER_SUGGESTION_ACTION_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Add the sender to a contact (new or existing) and capture the kept mail
   *
   * @generated from enum value: EMAIL_SENDER_SUGGESTION_ACTION_ENUM_LINK_CONTACT = 1;
   */
  LINK_CONTACT = 1,

  /**
   * Never capture or suggest this sender again
   *
   * @generated from enum value: EMAIL_SENDER_SUGGESTION_ACTION_ENUM_IGNORE_SENDER = 2;
   */
  IGNORE_SENDER = 2,

  /**
   * Dismiss this suggestion only
   *
   * @generated from enum value: EMAIL_SENDER_SUGGESTION_ACTION_ENUM_IGNORE_ONCE = 3;
   */
  IGNORE_ONCE = 3,
}

/**
 * Describes the enum cortado.v1.EmailSenderSuggestionActionEnum.
 */
export const EmailSenderSuggestionActionEnumSchema: GenEnum<EmailSenderSuggestionActionEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_emails, 10);

